/*
 *  REST Service object: TrackerRest
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { DowngradeInjectable } from '@angular/upgrade/static';
//declare var angular: angular.IAngularStatic;
import { Observable } from 'rxjs';
import { doGetPromise } from '../../../core/config/core.httpclient-utils';
@Injectable()
export class FrsReleaseService {

    constructor(private http: HttpClient) {
        this.http = http;
    }

    fetch(unixName: string = '', params: any = {}) {
        return doGetPromise(this.http, `/api/frsrelease/${unixName}/release`, params);
    }

    fetchDetails(frsReleaseId: number = 0, params: any = {}) {
        return doGetPromise(this.http, `/api/frsrelease/${frsReleaseId}/details`, params);
    }

    getRecent(unixName: string = '') {
        return doGetPromise(this.http, `/api/frsrelease/${unixName}/release?recentReleases=Y&isReleased=Y&sort_field=releaseDate&sort_dir=desc&rel=files`);
    }

    getUnreleased(unixName: string = '') {
        return doGetPromise(this.http, `/api/frsrelease/${unixName}/release?isReleased=N&sort_field=id&sort_dir=desc`);
    }

    getRoadmap(unixName: string = '') {
        return doGetPromise(this.http, `/api/frsrelease/${unixName}/release?page_size=999&page_num=1&isReleased=N&sort_field=releaseDate&sort_dir=asc&rel=tisummary`);
    }

    getTrackerItems(frsReleaseId: number = 0) {
        return doGetPromise(this.http, `/api/frsrelease/${frsReleaseId}/trackeritems`);
    }

    getBurndown(frsReleaseId: number = 0, params: any = {}) {
        return doGetPromise(this.http, `/api/frsrelease/${frsReleaseId}/burndown`, params);
    }

    save(frsReleaseId: number = 0, data: any = {}) {
        return this.http.post(`/api/frsrelease/${frsReleaseId}`, data)
            .toPromise();
    }

    delete(frsReleaseId: number = 0) {
        return this.http.delete(`/api/frsrelease/${frsReleaseId}`)
        .toPromise(); 
    }
    
    saveFile(frsReleaseId: number = 0, data: any = {}) {
        return this.http.post(`/api/frsrelease/${frsReleaseId}/releasefile`, data)
            .toPromise();
    }

    deleteFile(frsReleaseId: number = 0, fileId: number = 0) {
        return this.http.delete(`/api/frsrelease/${frsReleaseId}/releasefile/${fileId}`)
            .toPromise();
    }
}
